// extracted by mini-css-extract-plugin
export default {"markdownContainer":"ArticleStyling_markdownContainer__B7ZNC","centeredImage":"ArticleStyling_centeredImage__Bpr6l","section-item":"ArticleStyling_section-item__9bP07"};